<template>
  <div class="wrapper">
    <div class="title">Bookings vs Week Prior</div>
    <div id="TotalBookingsChart"></div>
  </div>
</template>

<script>
const am4core = require("@amcharts/amcharts4/core");
const am4charts = require("@amcharts/amcharts4/charts");
const dayjs = require("dayjs");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
import am4themes_material from "@amcharts/amcharts4/themes/material";
export default {
  components: {},
  props: {
    stats: {
      type: Object,
      required: true,
    },
    customers: {
      type: Array,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
    selectedDate: {
      type: Date,
      required: true,
    },
  },
  data: function () {
    return {
      chart: {},
      chartData: [],
      currentTimezone: dayjs.tz.guess(),
      formattedSelectedDate: dayjs(this.selectedDate),
    };
  },
  methods: {
    PerCustomer: async function () {
      am4core.useTheme(am4themes_material);
      let chart = am4core.create("TotalBookingsChart", am4charts.XYChart);
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "date";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.rotation = 300;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      for (const [key, dateData] of Object.entries(this.stats)) {
        const Obj = {};
        let dateObj = new Date(key);
        Obj.date =
          dateObj.getDate() + "/" + this.appendLeadingZeroes(dateObj.getMonth() + 1) + " " + this.appendLeadingZeroes(dateObj.getHours()) + ":" + this.appendLeadingZeroes(dateObj.getMinutes());
        for (const [customerId, customerData] of Object.entries(dateData)) {
          Obj[this.customers[customerId].customer_name] = customerData.booked;
          if (Obj[this.customers[customerId].customer_name] == undefined) {
            Obj[this.customers[customerId].customer_name] = 0;
          }
        }
        this.chartData.push(Obj);
      }
      chart.data = this.chartData;
      for (const [key, customer] of Object.entries(this.customers)) {
        const series = new am4charts.ColumnSeries();
        series.dataFields.valueY = `${customer.customer_name}`;
        series.dataFields.categoryX = "date";
        series.name = `${customer.customer_name}`;
        series.stacked = true;
        series.tooltipText = `${customer.customer_name} - {valueY}`;
        chart.series.push(series);
      }
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.maxTooltipDistance = 10;
    },
    GlobalBookings: async function () {
      am4core.useTheme(am4themes_material);
      let chart = am4core.create("TotalBookingsChart", am4charts.XYChart);
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "date";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.rotation = 300;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      for (const [key, dateData] of Object.entries(this.stats)) {
        const Obj = {
          bookings: 0,
        };
        let dateObj = new Date(key);
        Obj.date =
          dateObj.getDate() + "/" + this.appendLeadingZeroes(dateObj.getMonth() + 1) + " " + this.appendLeadingZeroes(dateObj.getHours()) + ":" + this.appendLeadingZeroes(dateObj.getMinutes());
        for (const [customerId, customerData] of Object.entries(dateData)) {
          if (customerData.Booked != undefined) {
            Obj.bookings += customerData.Booked;
            Obj.bookings += customerData.booked;
          }
        }
        this.chartData.push(Obj);
      }
      chart.data = this.chartData;
      const series = new am4charts.ColumnSeries();
      series.dataFields.valueY = `bookings`;
      series.dataFields.categoryX = "date";
      series.name = `bookings`;
      series.stacked = true;
      series.tooltipText = `bookings - {valueY}`;
      chart.series.push(series);
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.maxTooltipDistance = 10;
    },
    TodayVsLastweek: async function () {
      am4core.useTheme(am4themes_material);
      this.chart = am4core.create("TotalBookingsChart", am4charts.XYChart);
      let chart = this.chart;
      chart.legend = new am4charts.Legend();
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "time";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.rotation = 300;
      chart.yAxes.push(new am4charts.ValueAxis());

      let today = this.stats[this.formattedSelectedDate.format("DD-MM-YYYY")];
      let todaysDate = this.formattedSelectedDate.format("DD-MM-YYYY");
      let lastWeek = this.stats[dayjs(this.selectedDate).subtract(7, "day").format("DD-MM-YYYY")];

      const dataObj = {};
      for (const [time, timeData] of Object.entries(today)) {
        let date = dayjs(`${todaysDate} ${time}`, "DD-MM-YYYY HH:mm").utc(true);
        if (!dataObj[time]) {
          dataObj[time] = {
            lastWeekBookings: 0,
            lastWeekFullyBooked: 0,
            time: dayjs.tz(date, this.currentTimezone).format("HH:mm"),
          };
        }
        for (const [customerId, customerData] of Object.entries(timeData)) {
          if (customerData.Booked != undefined || customerData.booked != undefined) {
            if (!dataObj[time].bookings) {
              dataObj[time].bookings = 0;
            }
            if (customerData.Booked != undefined) dataObj[time].bookings += customerData.Booked;
            if (customerData.booked != undefined) dataObj[time].bookings += customerData.booked;
          }
          if (customerData.fully_booked != undefined) {
            if (!dataObj[time].fullybooked) dataObj[time].fullybooked = 0;
            dataObj[time].fullybooked += customerData.fully_booked;
          }
        }
      }
      for (const [time, timeData] of Object.entries(lastWeek)) {
        let date = dayjs(`${todaysDate} ${time}`, "DD-MM-YYYY HH:mm").utc(true);
        if (!dataObj[time]) {
          dataObj[time] = {
            lastWeekBookings: 0,
            lastWeekFullyBooked: 0,
            time: dayjs.tz(date, this.currentTimezone).format("HH:mm"),
          };
        }
        for (const [customerId, customerData] of Object.entries(timeData)) {
          if (customerData.Booked != undefined) {
            dataObj[time].lastWeekBookings += customerData.Booked;
          }
          if (customerData.booked != undefined) {
            dataObj[time].lastWeekBookings += customerData.booked;
          }
          if (customerData.fullybooked != undefined) {
            if (!dataObj[time].lastWeekFullyBooked) dataObj[time].lastWeekFullyBooked = 0;
            dataObj[time].lastWeekFullyBooked += customerData.fullybooked;
            if (customerData.fully_booked != undefined) dataObj[time].lastWeekFullyBooked += customerData.fully_booked;
          }
        }
      }
      for (const [key, value] of Object.entries(dataObj)) {
        this.chartData.push(value);
      }
      chart.data = this.chartData;

      let lastWeekSeries = new am4charts.LineSeries();
      lastWeekSeries.dataFields.valueY = `lastWeekBookings`;
      lastWeekSeries.dataFields.categoryX = "time";
      lastWeekSeries.stroke = am4core.color("grey");
      lastWeekSeries.strokeWidth = 4;
      lastWeekSeries.fill = am4core.color("grey");
      lastWeekSeries.tooltipText = `Week Prior Bookings: {lastWeekBookings} ({lastWeekFullyBooked} fully booked)`;
      lastWeekSeries.tooltip.background.fill = am4core.color("grey");
      lastWeekSeries.propertyFields.stroke = am4core.color("grey");
      lastWeekSeries.propertyFields.fill = am4core.color("grey");
      lastWeekSeries.fillOpacity = 0.5;
      lastWeekSeries.name = `Week Prior Bookings`;
      chart.series.push(lastWeekSeries);

      let series = new am4charts.LineSeries();
      series.dataFields.valueY = `bookings`;
      series.dataFields.categoryX = "time";
      series.stroke = am4core.color("#47d061");
      series.strokeWidth = 4;
      series.fill = am4core.color("#47d061");
      series.tooltipText = `Bookings: {bookings} ({fullybooked} fully booked)`;
      series.tooltip.background.fill = am4core.color("#47d061");
      series.name = `Bookings`;
      chart.series.push(series);

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.maxTooltipDistance = 20;
    },
    appendLeadingZeroes(n) {
      if (n <= 9) {
        return "0" + n;
      }
      return n;
    },
  },
  mounted() {
    switch (this.mode.toLowerCase()) {
      case "global":
        this.GlobalBookings();
        break;
      case "customer":
        this.PerCustomer();
        break;
      case "todayvslastweek":
        this.TodayVsLastweek();
        break;
      default:
        break;
    }
  },
  beforeDestroy() {
    this.chart.dispose();
  },
};
</script>

<style scoped>
#TotalBookingsChart {
  height: calc(100% - 20px);
  width: inherit;
  display: block;
}

.wrapper {
  height: inherit;
  width: inherit;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 20fr;
  height: 300px;
}

.title {
  font-size: 1.2em;
  display: flex;
  justify-content: center;
}
</style>
